import React from 'react';
import { DateTimeRangePicker, Flex } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DateTimeRangeEditor(props) {
  const {
    eventData,
    value,
    onChange
  } = props;
  const v = value && typeof value === 'object' ? {
    ...value
  } : value;
  if (v && typeof v.start === 'string') {
    v.start = new Date(v.start);
  }
  if (v && typeof v.end === 'string') {
    v.end = new Date(v.end);
  }
  return /*#__PURE__*/_jsx(Flex, {
    variant: "rowM",
    align: "center",
    children: /*#__PURE__*/_jsx(DateTimeRangePicker, {
      variant: "dashboardOption",
      value: v,
      eventData: eventData,
      onChange: onChange
    })
  });
}
DateTimeRangeEditor.TYPE = 'dateTimeRange';